import { render, staticRenderFns } from "./PromotionsList.vue?vue&type=template&id=6aa4dcd8&scoped=true"
import script from "./PromotionsList.vue?vue&type=script&lang=js"
export * from "./PromotionsList.vue?vue&type=script&lang=js"
import style0 from "./PromotionsList.vue?vue&type=style&index=0&id=6aa4dcd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa4dcd8",
  null
  
)

export default component.exports